/**
 * Collection page grid <-> list view toggle
 * Targets #product-grid and toggles .view-list class
 * Persists preference in localStorage
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'cbbc_collection_view';

  function getGrid() {
    return document.getElementById('product-grid');
  }

  function applyView(view) {
    var grid = getGrid();
    if (!grid) return;

    if (view === 'list') {
      grid.classList.add('view-list');
    } else {
      grid.classList.remove('view-list');
    }

    document.querySelectorAll('.thb-view-toggle__btn').forEach(function (btn) {
      var isActive = btn.dataset.view === view;
      btn.classList.toggle('is-active', isActive);
      btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
  }

  function savedView() {
    try {
      return localStorage.getItem(STORAGE_KEY) || 'grid';
    } catch (e) {
      return 'grid';
    }
  }

  function saveView(view) {
    try {
      localStorage.setItem(STORAGE_KEY, view);
    } catch (e) {}
  }

  function init() {
    applyView(savedView());

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.thb-view-toggle__btn');
      if (!btn) return;
      var view = btn.dataset.view;
      if (!view) return;
      applyView(view);
      saveView(view);
    });
  }

  // Re-apply view after AJAX filter updates (Shopify facets replace the grid)
  var observer = new MutationObserver(function () {
    var grid = getGrid();
    if (!grid) return;
    if (savedView() === 'list' && !grid.classList.contains('view-list')) {
      applyView('list');
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
      var container = document.getElementById('ProductGridContainer');
      if (container) observer.observe(container, { childList: true, subtree: true });
    });
  } else {
    init();
    var container = document.getElementById('ProductGridContainer');
    if (container) observer.observe(container, { childList: true, subtree: true });
  }
})();
